import { ChooseYourPlan } from './ChooseYourPlan';
import { PlansAndBilling } from './PlansAndBilling';

export const ChooseYourPlanPage = () => {
  return <ChooseYourPlan />;
};

export const PlansAndBillingPage = () => {
  return <PlansAndBilling />;
};

